import formatFileSize from './utils'

const messages = {
  _default: () => `ogiltigt värde.`,
  after: (field, [target, inclusion]) =>
    `måste vara efter ${inclusion ? 'eller samma som ' : ''}${target}.`,
  alpha_dash: () =>
    `fältet får innehålla alfanumeriska tecken binde och understreck.`,
  alpha_num: () =>
    `fältet får endast innehålla alfanumeriska tecken.`,
  alpha_spaces: () =>
    `fältet får endast innehålla alfanumeriska tecken och mellanslag.`,
  alpha: () => `fältet får endast innehålla bokstäver.`,
  before: (field, [target, inclusion]) =>
    `måste vara före ${inclusion ? 'eller samma som ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `fältet måste vara mellan ${min} och ${max}.`,
  confirmed: () => `bekräftelsen matchar ej.`,
  credit_card: () => `fältet är ogiltigt.`,
  date_between: (field, [min, max]) =>
    `måste vara mellan ${min} och ${max}.`,
  date_format: (field, [format]) =>
    `must be in the format ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `fältet måste innehålla siffror och får innehålla ${
      !decimals || decimals === '*' ? '' : decimals
    } decimaltecken.`,
  digits: (field, [length]) =>
    `fältet måste vara numeriskt och precist innehålla ${length} siffror.`,
  dimensions: (field, [width, height]) =>
    `fältet måste vara ${width} pixlar x ${height} pixels.`,
  email: () => `fältet måste vara en giltig e-mejl.`,
  ext: () => `fältet måste vara rätt filformat.`,
  image: () => `fältet måste vara en bild.`,
  in: () => `fältet måste vara ett giltigt värde.`,
  integer: () => `fältet måste vara ett heltal.`,
  ip: () => `fältet måste vara en ip-adress.`,
  length: (field, [length, max]) => {
    if (max) {
      return `längd måste vara mellan ${length} och ${max}.`
    }

    return `längd måste vara ${length}.`
  },
  max: (field, [length]) =>
    `fältet får inte vara längre än ${length} tecken.`,
  max_value: (field, [max]) => `fältet måste vara ${max} eller mindre.`,
  mimes: () => `fältet måste innehålla en giltig filtyp.`,
  min: (field, [length]) =>
    `fältet måste innehålla minst ${length} tecken.`,
  min_value: (field, [min]) => `fältet måste vara ${min} eller fler.`,
  not_in: () => `fältet måste vara ett giltigt värde.`,
  numeric: () => `fältet får endast innehålla siffror.`,
  regex: () => `fältets format är ogiltigt.`,
  required: () => `fältet är obligatoriskt.`,
  size: (field, [size]) =>
    `storlet måste vara mindre än ${formatFileSize(size)}.`,
  url: () => `fältet är inte en giltig URL.`,
  fullName: () => 'Är ej giltig (namn, förnamn och max 120. tecken)',
  emailInput: () => 'fältet måste vara en giltig e-mejl.',
  fullNamePerCountry: () => 'Är ej giltig (namn, förnamn och max 18. tecken)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'sv',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/sv.js